import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCheckbox, LazyRadioButton, LazyRating, LazySelect, LazySlider, LazyButton, LazyAccordion, LazyAccordionTab, LazyDialog, LazyPopover, LazyProgressBar } from '#components'
const lazyGlobalComponents = [
  ["Checkbox", LazyCheckbox],
["RadioButton", LazyRadioButton],
["Rating", LazyRating],
["Select", LazySelect],
["Slider", LazySlider],
["Button", LazyButton],
["Accordion", LazyAccordion],
["AccordionTab", LazyAccordionTab],
["Dialog", LazyDialog],
["Popover", LazyPopover],
["ProgressBar", LazyProgressBar],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
